"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Theme from "../Theme/index.js";
import Text from "../Text/index.js";
import Flyout from "../Flyout/index.js";
import s from "./Tooltip.module.css";
const Tooltip = (props) => {
    const { text, children, position = "bottom", color = "inverted", ...flyoutProps } = props;
    if (!text)
        return children({ ref: null });
    return (_jsxs(Flyout, { ...flyoutProps, position: position, triggerType: "hover", groupTimeouts: true, children: [_jsx(Flyout.Trigger, { children: children }), _jsx(Flyout.Content, { children: _jsx(Theme, { colorMode: color, children: _jsx(Text, { variant: "caption-1", className: s.root, children: text }) }) })] }));
};
Tooltip.displayName = "Tooltip";
export default Tooltip;
